/**
 * @file process.js
 * @fileOverview Env configurations
 * @author Smartmatic
 * @creationDate 2020-08-20
 * @modificationDate 2025-02-20
 */
export const MODE = process.env.REACT_APP_VOTE_MODE || 'ISB';
export const VERSION = process.env.REACT_APP_VERSION;
export const IS_DEV = process.env.NODE_ENV === 'development';
